<div class="drivePlus" [ngClass]="tierClass">
  <div class="drivePlus__card">
    <!-- Sits at the card's top-right, which is where the design puts it in both
         the desktop and mobile layouts. -->
    <mat-checkbox
      *ngIf="showSelectionCheckbox"
      class="drivePlus__checkbox"
      [checked]="selected"
      (change)="onSelectedChange($event.checked)"
    ></mat-checkbox>

    <div class="drivePlus__card__media">
      <div class="drivePlus__badge">
        <img src="/assets/image/driveplus/crown.png" alt="" />
        <span>{{ "plans.motorMembership.LoyaltyProgramme" | translate }}</span>
      </div>

      <div class="drivePlus__brand">
        <div class="drivePlus__brand__title">
          {{ "plans.motorMembership.DrivePlus" | translate }}
        </div>
        <div class="drivePlus__brand__desc">
          {{ "plans.motorMembership.DrivePlusDesc" | translate }}
        </div>
      </div>
    </div>

    <div class="drivePlus__card__content">
      <div class="drivePlus__card__chooseTier">
        {{ "plans.motorMembership.ChooseYourTier" | translate }}
      </div>

      <div class="drivePlus__card__btn">
        <button
          mat-stroked-button
          color="primary"
          class="driveplus-btn"
          *ngFor="let t of tiers"
          [ngClass]="{ selected: isTierSelected(t) }"
          (click)="onTierClick(t)"
        >
          <span class="driveplus-btn__name">
            {{ tierLabelKey(t) | translate }}
          </span>
          <span class="driveplus-btn__price">
            RM {{ t.evaluate | number : "1.2-2" }}
          </span>
        </button>
      </div>

      <div class="drivePlus__card__priceRow">
        <div class="drivePlus__card__special">
          <span class="small">RM</span>{{ price | number : "1.2-2" }}
        </div>

        <div class="drivePlus__card__wasPrice" *ngIf="savings > 0">
          <span class="strikethrough">RM{{ wasPrice | number : "1.2-2" }}</span>
          <span class="drivePlus__card__savePill">
            {{
              "plans.motorMembership.Save"
                | translate : { amount: (savings | number : "1.2-2") }
            }}
          </span>
        </div>
      </div>

      <div class="drivePlus__card__flex2">
        <div class="drivePlus__card__roadtax">
          <div class="drivePlus__card__roadtax__label">
            {{ "plans.motorMembership.RoadtaxWithPremium" | translate }}
          </div>
          <div class="drivePlus__card__roadtax__specialPrice">
            <span class="strikethrough">
              RM{{ originalRoadTaxPrice | number : "1.2-2" }}
            </span>
            <span class="specialPrice">
              <ng-container *ngIf="isRoadtaxFree; else roadtaxAmount">
                {{ "plans.motorMembership.Free" | translate }}
              </ng-container>
              <ng-template #roadtaxAmount>
                RM{{ roadtaxPrice | number : "1.2-2" }}
              </ng-template>
            </span>
          </div>
        </div>

        <div class="drivePlus__card__loyaltyPill">
          <img src="/assets/image/driveplus/redeem.png" alt="" />
          <span
            [innerHTML]="
              'plans.motorMembership.LoyaltyRewardsPill'
                | translate
                  : { amount: (loyaltyRewardsTotal | number : '1.0-0') }
            "
          ></span>
        </div>

        <div class="drivePlus__card__benefits">
          <div
            class="drivePlus__card__benefits__list"
            *ngFor="let benefit of benefits"
          >
            <img src="/assets/icons/check_circle.png" alt="" />
            <span
              [innerHTML]="
                benefitLabelKey(benefit)
                  | translate : benefitLabelParams(benefit)
              "
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
